import "./home.css";

import React from "react";
import { Link } from "react-router-dom";

import { CONTACT_DETAILS, HOME, ROUTES } from "../../data/content";
import Consultation from "../general/Consultation";
import { WhatsAppIcon } from "../general/Icons";
import Lightbox from "../general/Lightbox";
import PageHero from "../general/PageHero";
import PageMeta from "../general/PageMeta";
import Slideshow from "../general/Slideshow";
import Tabs from "../general/Tabs";

//One room tab: slideshow on the left, title, text & link on the right
const RoomPanel = ({ room }) => {
  const [openIndex, setOpenIndex] = React.useState(null);

  return (
    <div className={"home-room"}>
      <div className={"home-room-photos"}>
        <Slideshow
          photos={room.PHOTOS}
          label={`${room.TAB} photos`}
          autoPlay={4000}
          sizes={"(max-width: 800px) 100vw, 50vw"}
          onOpen={setOpenIndex}
        />
      </div>
      <div className={"home-room-text"}>
        <h3 className={"section-title"}>{room.TITLE}</h3>
        <p className={"body-text"}>{room.TEXT}</p>
        <Link
          to={room.LINK}
          className={"btn"}
        >
          {room.BUTTON}
        </Link>
      </div>
      <Lightbox
        title={room.TAB}
        photos={room.PHOTOS}
        index={openIndex}
        onClose={() => setOpenIndex(null)}
      />
    </div>
  );
};

const Home = () => {
  const { INTRO, ROOMS, SHOWROOM } = HOME;

  return (
    <React.Fragment>
      <PageMeta
        title={"Graylag & Co | Home"}
        isFullTitle
      />
      <h1 className={"visually-hidden"}>Graylag & Co - Kitchens, Cupboards, Bespoke Cabinetry</h1>
      <PageHero />

      <section className={"intro"}>
        <h2 className={"section-title"}>{INTRO.TITLE}</h2>
        <p className={"body-text"}>{INTRO.TEXT}</p>
      </section>

      <section
        className={"home-rooms"}
        aria-label={"Our rooms"}
      >
        <Tabs
          id={"home-rooms"}
          labels={ROOMS.map((r) => r.TAB)}
          renderPanel={(i) => <RoomPanel room={ROOMS[i]} />}
        />
      </section>

      <section className={"home-showroom"}>
        <div className={"home-showroom-photo"}>
          <img
            src={SHOWROOM.LEFT_PHOTO.md}
            srcSet={SHOWROOM.LEFT_PHOTO.srcSet}
            sizes={"(max-width: 900px) 50vw, 30vw"}
            alt={SHOWROOM.LEFT_PHOTO.alt}
            width={SHOWROOM.LEFT_PHOTO.width}
            height={SHOWROOM.LEFT_PHOTO.height}
            loading={"lazy"}
          />
        </div>
        <div className={"home-showroom-text"}>
          <h2 className={"section-title"}>{SHOWROOM.TITLE}</h2>
          <p className={"body-text"}>{SHOWROOM.TEXT}</p>
          <div className={"home-showroom-buttons"}>
            <Link
              to={ROUTES.SHOWROOM}
              className={"btn"}
            >
              Learn More
            </Link>
            <a
              href={CONTACT_DETAILS.WHATSAPP_LINK}
              className={"btn"}
              target={"_blank"}
              rel={"noopener noreferrer"}
            >
              <WhatsAppIcon />
              Chat on WhatsApp
            </a>
          </div>
        </div>
        <div className={"home-showroom-photo"}>
          <img
            src={SHOWROOM.RIGHT_PHOTO.md}
            srcSet={SHOWROOM.RIGHT_PHOTO.srcSet}
            sizes={"(max-width: 900px) 50vw, 30vw"}
            alt={SHOWROOM.RIGHT_PHOTO.alt}
            width={SHOWROOM.RIGHT_PHOTO.width}
            height={SHOWROOM.RIGHT_PHOTO.height}
            loading={"lazy"}
          />
        </div>
      </section>

      <Consultation />
    </React.Fragment>
  );
};

export default Home;
